import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Content from './Content';
import './styles.css';

class InboxLayout extends Component {
	render() {
		const { children } = this.props;
		return <div className="inbox-layout">{children}</div>;
	}
}
InboxLayout.propTypes = {
	children: PropTypes.node
};

class SideBar extends Component {
	render() {
		const { children } = this.props;
		return <div className="inbox-layout-sidebar">{children}</div>;
	}
}
SideBar.propTypes = {
	children: PropTypes.node
};

Object.assign(InboxLayout, {
	SideBar,
	Content
});
export default InboxLayout;
